<template>
    <section>
        <el-col :span="24" style="padding-bottom: 0;" size="small">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-autocomplete v-model="filters.type" :fetch-suggestions="querySearch" size="small" placeholder="设备类型" style="width:400px; "></el-autocomplete>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="queryBtn()" icon="el-icon-search" size="small" :disabled="!isDev">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" :disabled="!isAuth('device:add')">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <!--列表-->
        <el-table :data="deviceList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" size="small">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="60" :index="indexMethod"></el-table-column>
            <el-table-column prop="type" label="设备类型" width="500" align="center"></el-table-column>
            <el-table-column prop="board" label="BoardID" width="150" align="center"></el-table-column>
            <el-table-column prop="description" label="备注" min-width="300" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)" :disabled="!isAuth('feature:update')">编辑</el-button>
                    <el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)" :disabled="!isAuth('feature:del')">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                :total="total" :current-page.sync="page" style="float:right;">
            </el-pagination>
        </el-col>

        <el-alert
            title="备注"
            type="success"
            description="设备类型中包含“[”, “]”符号存在查询问题，新增设备时切勿添加此符号" :closable="false">
        </el-alert>

        <!--编辑界面-->
        <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="editForm" label-width="80px" ref="editForm" size="small" :rules="editFormRules">
                <el-form-item label="设备类型" prop="type">
                    <el-input v-model="editForm.type" maxlength="60"></el-input>
                </el-form-item>
                <el-form-item label="BoardID" prop="board">
                    <el-input v-model="editForm.board" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <el-input v-model="editForm.description"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
            <el-form :model="addForm" label-width="80px" ref="addForm" size="small" :rules="addFormRules">
                <el-form-item label="设备类型" prop="type">
                    <el-input v-model="addForm.type" maxlength="60"></el-input>
                </el-form-item>
                <el-form-item label="BoardID" prop="board">
                    <el-input v-model="addForm.board" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="note">
                    <el-input v-model="addForm.description"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import {getDeviceList, getDeviceInfo, removeDevice, addDevice, modifyDevice, getDepotList} from "../../../api/api";
import { isAuth } from '../../../utils';

    export default {
        data(){
            return{
                filters:{
                    type:''
                },
                isDev: false,
                devices:[],
                deviceList:[],
                total: 0,
                page: 1,
                listLoading:false,
                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                editForm: {
                    id: '',
                    type: '',
                    board: '',
                    description: ''
                },
                editFormRules: {
                    type: [{
                        required: true,
                        message: '请输入设备类型',
                        trigger: 'blur'
                    }],
                    board: [{
                        required: true,
                        message: '请输入设备Boardid',
                        trigger: 'blur'
                    }]
                },
                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                addForm:{
                    type:'',
                    board:'',
                    description: ''
                },
                addFormRules: {
                    type: [{
                        required: true,
                        message: '请输入设备类型',
                        trigger: 'blur'
                    }],
                    board: [{
                        required: true,
                        message: '请输入设备boardid',
                        trigger: 'blur'
                    }],
                }
            }
        },
        methods:{
            querySearch(queryString, cb) {
                let devices = this.devices;
                let results = queryString ? devices.filter(this.createFilter(queryString)) : devices;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (device) => {
                    return (device.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            indexMethod(row) {
                return row + (this.page - 1) * 10 + 1
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getDeviceList();
            },
            getDeviceInfo() {
                getDeviceInfo().then((res) => {
                    if(res.data.code === 0){
                        let deviceList = res.data.deviceList.content;
                        this.devices = [];
                        for(let i = 0;i < deviceList.length;i++){
                            let device = {};
                            device.value = deviceList[i].type;
                            this.devices.push(device);
                        }
                    }
                })
            },

          queryBtn(){
            this.page=1;
            this.getDeviceList();
          },
            getDeviceList(){
                let para = {
                    page: this.page - 1,
                    size: 10,
                    type: this.filters.type
                };
                this.listLoading = true;
                getDeviceList(para).then((res) => {
                    if(res.data.code === 0){
                        this.deviceList = res.data.deviceList.content;
                        this.total = res.data.deviceList.totalElements;
                    }else {
                        this.$message.error("获取设备列表失败，请稍后重新获取")
                    }
                    this.listLoading = false;
                })
            },
            //删除
            handleDel: function (index, row) {
                this.$confirm('确认删除该设备信息吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    let para = {
                        id: row.id
                     };
                    removeDevice(para).then((res) => {
                        if(res.data.code === 0){
                            this.$message.success("删除成功")
                        }else{
                            this.$message.error("删除失败")
                        }
                        this.listLoading = false;
                        this.getDeviceList();
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;

                this.addForm = {
                    type: '',
                    board:'',
                    description:''
                };
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            let para = {
                                id: this.editForm.id,
                                type: this.editForm.type,
                                board: this.editForm.board.toLowerCase(),
                                description: this.editForm.description
                            }
                            modifyDevice(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('修改成功');
                                } else {
                                    this.$message.error('修改失败');
                                }
                                this.editLoading = false;
                                this.$refs['editForm'].resetFields();
                                this.editFormVisible = false;
                                this.getDeviceList();
                            });
                        });
                    }
                })
            },

            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            let para = {
                                type: this.addForm.type,
                                board: this.addForm.board.toLowerCase(),
                                description: this.addForm.description
                            }
                            addDevice(para).then((res) => {
                                if (res.data.code === 0) {
                                    this.$message.success('添加成功');
                                } else {
                                    this.$message.error('添加失败');
                                }
                                this.addLoading = false;

                                this.$refs['addForm'].resetFields();
                                this.addFormVisible = false;
                                this.getDeviceList();
                            });
                        });
                    }
                })
            },
            selsChange: function (sels) {
              this.sels = sels;
            }
        },
        activated(){
            this.isDev = isAuth('device:list');
            if(this.isDev){
                this.getDeviceInfo();
                this.getDeviceList();
            }
        }
    }
</script>

<style slot-scope>

</style>



// WEBPACK FOOTER //
// src/views/modules/conf/dev.vue